import { MostActiveMembersRpc } from "../../lib/discordTypes";
import { List, Avatar } from "antd";
import { DiscordMemberModal, SlackMemberModal } from "../../lib/memberModal";
import { useContext } from "react";
import { GlobalModalContext } from "../GlobalModalContext/GlobalModalContext";

interface SlackUserListItem {
  image: string;
  name: string;
  messages: number;
  slack_id?: string;
}

type Props = {
  user: SlackUserListItem | MostActiveMembersRpc;
};

/**
 * Component that displays a user on discord or slakc as an antd list item
 * that can be clicked to open a member modal.
 */
export default function UserListItem({ user }: Props) {
  const { setGlobalModal } = useContext(GlobalModalContext);
  const guildId = localStorage.getItem("guild-id");
  let image, memberModal: JSX.Element, platform: "discord" | "slack";

  if ("discord_id" in user) {
    platform = "discord";
    memberModal = (
      <DiscordMemberModal userId={`${user.discord_id}-${guildId}`} />
    );
    image = `https://cdn.discordapp.com/avatars/${user.discord_id}/${user.avatar}.png`;
  } else {
    platform = "slack";
    image = user.image;
  }
  if ("slack_id" in user && typeof user.slack_id !== "undefined")
    memberModal = (
      <SlackMemberModal member={{ slack_id: user.slack_id, name: user.name }} />
    );
  return (
    <List.Item>
      <List.Item.Meta
        avatar={<Avatar src={image || "/avatar_slack.png"} />}
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        title={
          <button
            onClick={() => {
              window.analytics.track(
                "Clicked on user in user list which opens a user modal",
                {
                  platform,
                  memberModalAvailable: memberModal ? true : false,
                }
              );
              memberModal && setGlobalModal(memberModal);
            }}
            className="hover:text-gray-600"
          >
            {user.name}
          </button>
        }
        // description={<p>{item.reaction_count} reactions</p>}
      />
      <div>
        {user.messages} {user.messages > 1 ? "messages" : "message"}
      </div>
    </List.Item>
  );
}
